
export class KennzahlFaktor {

    public static TYPE_CO2 = 'type_co2';
    public static TYPE_UMRECHNUNG = 'type_umrechnung';
    public static TYPE_HOCHRECHNUNG = 'type_hochrechnung';
    public static TYPE_GEWICHT = 'type_gewicht';
    public static TYPE_FAHRT = 'type_fahrt';
    public static TYPE_PERSONEN = 'type_personen';
    public static TYPE_ARBEITSTAGE = 'type_arbeitstage';

    constructor(value: number, type: string, quelle: string, info: string, einheit?: string) {
        this.value = value;
        this.type = type;
        this.quelle = quelle;
        this.info = info;
        this.einheit = einheit;
    }

    private quelle: string;
    private value: number;
    private type: string;
    private info: string;
    private formatType = 'fnAuto';
    private gtz: number;
    private gtzOrig: number;
    private tage: number;
    private tageOrig: number;
    private einheit: string;

    setGtz(gtz: number, gtzOrig: number): this {
        this.gtz = gtz;
        this.gtzOrig = gtzOrig;
        return this; // Builder-Pattern
    }

    getInfo() {
        return this.info;
    }

    getQuelle() {
        return this.quelle;
    }

    setTage(tage: number, tageOrig: number): this {
        this.tage = tage;
        this.tageOrig = tageOrig;
        return this; // Builder-Pattern
    }

    getType() {
        return this.type;
    }

    getValue() {
        return this.value;
    }
}
